import * as R from 'ramda';
import StatusRenderer from '../../components/StatusRenderer';
import { CurrencySymbol } from '../../hooks/useMoney.types';
import { useTranslation } from '../translation/TranslationContext';
import { TranslateType } from '../translation/translationContext.types';
import {
  ConditionValidationErrors,
  CustomerStatus,
  Status,
  StatusType,
  synchronizedStatus,
} from './order.types';

const statusTypeStrategy = {
  'order-status': Status,
  'integration-status': synchronizedStatus,
  'customer-status': CustomerStatus,
};

type StatusOrderProps = {
  status: string;
  size?: 'small' | 'medium' | 'large';
  fontSize?: number;
  statusType?: 'order-status' | 'integration-status' | 'customer-status';
};

export const StatusOrder = ({
  status = StatusType.DRAFT,
  statusType = 'order-status',
  size = 'small',
  ...props
}: StatusOrderProps) => {
  const { translate } = useTranslation();
  const statusTypeObj = statusTypeStrategy[statusType];

  return (
    <StatusRenderer
      status={status}
      color={statusTypeObj[status]?.color}
      label={translate(statusTypeObj[status]?.label)}
      size={size}
      {...props}
    />
  );
};

export const StatusCustomer = ({
  status = 'PENDING',
  statusType = 'customer-status',
  ...props
}: StatusOrderProps) => {
  const { translate } = useTranslation();
  const statusTypeObj = statusTypeStrategy[statusType];
  return (
    <StatusRenderer
      status={status}
      color={statusTypeObj[status]?.color}
      label={translate(statusTypeObj[status]?.label)}
      {...props}
    />
  );
};

export const transformUpdateResponse = (
  messages: ConditionValidationErrors[],
  formatMoney: (value: number) => string,
  translate: TranslateType,
  currencySymbol: CurrencySymbol,
) => {
  const uniqueMessages = R.uniqBy(
    (message: ConditionValidationErrors) => message.messageCode,
    messages,
  );

  const finalMessage = uniqueMessages
    .map((message: ConditionValidationErrors) => {
      const currency = message.extra?.type === 'CURRENCY' && message.extra?.quantity;
      const quantity = currency
        ? formatMoney(message.extra?.quantity as number)
        : (message.extra?.quantity as number);

      return translate(message.messageCode, {
        quantity,
        messageByItem: false,
        currency: currencySymbol,
        expected: '',
      });
    })
    .join('; ');
  return finalMessage;
};
